








































































import {Component, Vue} from "vue-property-decorator";
import {RouterStore} from '@/interfaces/store-interfaces/router-store.interface';
import Menu from "@/components/Menu.vue";
import {bus} from "@/plugins/bus";
import MiniRhizome from "@/components/MiniRhizome.vue";
import SwitchView from "@/components/SwitchView.vue";
import SearchKeyword from "@/components/SearchKeyword.vue";
import SelectKeyword from "@/components/SelectKeyword.vue";
import SearchInput from "@/components/Search.vue";
import ZoomSlider from '@/modules/Rhizome/components/ZoomSlider.vue'
import ROUTE_NAME = RouterStore.ROUTE_NAME;

@Component({
  components: {
    SearchKeyword,
    SwitchView,
    MiniRhizome,
    SearchInput,
    SelectKeyword,
    Menu,
    ZoomSlider
  }
})

export default class Header extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  route = RouterStore.ROUTE_NAME;
  routePath = RouterStore.ROUTE_PATH;
  isSearchPage: boolean = false;
  isSearchTitleActive: boolean = false;

  get isMenuOpen() {
    return this.$store.state.dialog.menu;
  }

  get controlsBelow() {
    return this.$store.state.rhizome.controlsBelow;
  }

  get isDetailPage() {
    return this.$router.currentRoute.name === RouterStore.ROUTE_NAME.DETAIL_PAGE;
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  set isMenuOpen(value) {
    this.$store.commit('dialog/setPropertyInState', { name: 'menu', value: value });
  }

  get isRhizomePage(): boolean {
    return this.$route.name === RouterStore.ROUTE_NAME.RHIZOME_PAGE;
  }

  created() {
    this.isSearchPage = this.$router.currentRoute.name === RouterStore.ROUTE_NAME.RHIZOME_PAGE;
  }

  mounted() {
    bus.$on('searchToggle', (state) => {
      this.isSearchTitleActive = state;
    });
  }

  async menuChange() {
    this.isMenuOpen = !this.isMenuOpen;
    this.isMenuOpen ? document.body.classList.add('overflow') : document.body.classList.remove('overflow');
  }

  async openRhizome() {
    if (this.isRhizomePage) {
      this.$store.commit('dialog/closeDialog', { dialogName: 'menu' });
      return;
    }

    this.$store.commit('rhizome/setPropertyInState', { name: 'showFavorites', value: false });
    this.$store.commit('dialog/closeDialog', { dialogName: 'menu' });

    if (this.isDetailPage) {
      await this.$store.dispatch('rhizome/openFilmOnRhizome', { filmId: Number(this.$router.currentRoute.params.id) });
    }
    else {
      await this.$store.dispatch('routerStore/openPage', { routeName: RouterStore.ROUTE_NAME.RHIZOME_PAGE });
    }
  }

  async closeRhizome() {
    if (!document.referrer.includes(window.location.host))
      await this.$store.dispatch('routerStore/openPage', { routeName: ROUTE_NAME.MAIN_PAGE });
    else
      await this.$router.back();
  }

  closeModal() {
    top.postMessage({ action: 'close-modal' }, window.location.origin)
  }

  closeMenu() {
    this.isMenuOpen = false;
    document.body.classList.remove('overflow');
  }

  async openLink(routeName: RouterStore.ROUTE_NAME) {
    this.closeMenu();
    this.$store.commit('dialog/closeDialog', { dialogName: 'menu' });
    await this.$store.dispatch('routerStore/openPage', { routeName });
  }

  showHistory() {
    this.isMenuOpen = false;

    bus.$emit('historyOpen');
  }

  openAboutModal() {
    this.$store.dispatch('rhizome/openAboutModal');
  }

  openHelpModal() {
    this.$store.dispatch('rhizome/openHelpModal');
  }

  addPressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.add('pressed');
    }
  }

  removePressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.remove('pressed');
    }
  }
  
  destroyed() {
    bus.$off('searchToggle');
  }
}
